/**
 * @generated SignedSource<<abd14502eb376b271e565a08332f2592>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "padding"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pages"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "variables"
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "documentId",
        "variableName": "documentId"
      },
      {
        "kind": "Variable",
        "name": "offerId",
        "variableName": "offerId"
      },
      {
        "kind": "Variable",
        "name": "padding",
        "variableName": "padding"
      },
      {
        "kind": "Variable",
        "name": "pages",
        "variableName": "pages"
      },
      {
        "kind": "Variable",
        "name": "variables",
        "variableName": "variables"
      }
    ],
    "concreteType": "StructuredHtmlMutationResponse",
    "kind": "LinkedField",
    "name": "generateStructuredHtml",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "html",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateStructuredHtmlMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GenerateStructuredHtmlMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "cd7e3fd2d8f8431cbc527da1dc0ed497",
    "id": null,
    "metadata": {},
    "name": "GenerateStructuredHtmlMutation",
    "operationKind": "mutation",
    "text": "mutation GenerateStructuredHtmlMutation(\n  $offerId: ID\n  $pages: [DocumentSectionInput!]\n  $documentId: ID\n  $variables: String\n  $padding: PaddingInput\n) {\n  generateStructuredHtml(offerId: $offerId, pages: $pages, documentId: $documentId, variables: $variables, padding: $padding) {\n    ok\n    error\n    html\n    filename\n  }\n}\n"
  }
};
})();

node.hash = "479d6ef1b50d513ed002ba83299a2ec9";

export default node;
